import React from "react";
import PropTypes from "prop-types";
import { Message } from "react-message-context";

const InvalidError = ({ noLineBreaks }) => {
  const space = noLineBreaks ? <>&nbsp;</> : <br />;

  const normal = (
    <>
      <Message id="feedback.form.textArea.error.title" />
      {space}
      <Message id="feedback.form.textArea.error.text" />
    </>
  );
  const sr = (
    <>
      <Message id="feedback.form.textArea.error.title" />
      {space}
      <Message id="feedback.form.textArea.srError.text" />
    </>
  );

  return (
    <>
      <span aria-labelledby="CFF-srError">
        <span aria-hidden="true">{normal}</span>
      </span>
      <span id="CFF-srError" className="cff-srOnly">
        {sr}
      </span>
    </>
  );
};

InvalidError.propTypes = {
  noLineBreaks: PropTypes.bool,
};

export default InvalidError;
